import { routerReducer } from 'react-router-redux';
import { combineReducers } from 'redux';

import authReducer from '../reducers/auth';
import upaDataReducer from '../reducers/upa-data';
import problemsFilterReducer from '../reducers/filters';

import createHistory from 'history/createBrowserHistory';
import createSagaMiddleware from 'redux-saga';
import { routerMiddleware } from 'react-router-redux';
import { applyMiddleware, createStore } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';

import localForage from 'localforage';
import sagas from './config-sagas';

localForage.config({
  name: 'UPA',
  storeName: 'upa'
});

const reducer = combineReducers({
  auth: authReducer,
  upaData: upaDataReducer,
  filter: problemsFilterReducer,
  router: routerReducer
});

const persistConfig = {
  key: 'root',
  storage: localForage
};

export const history = createHistory();
const sagaMiddleware = createSagaMiddleware();

const middleware = applyMiddleware(
  routerMiddleware(history),
  sagaMiddleware
);

const persistedReducer = persistReducer(persistConfig, reducer);

export const store = createStore(persistedReducer, middleware);
export const persistor = persistStore(store);

sagaMiddleware.run(sagas);



// WEBPACK FOOTER //
// ./src/config/config-reducers.js